/**
 * @file global.tsx
 * This file contains global configurations used throughout the project.
 */

/**
 * `global` - an object to store the environment configuration.
 * @type {Object}
 * @property {string} environment - Specifies the working environment.
 *                                  'prod' for production,
 *                                  'dev' for development,
 *                                  'local' for local development.
 */
export const global = {
  environment: 'prod',
  // Storage name in azure storage.
  storage_name: 'bloomaistorage',

  // Container name for specific data within the storage system.
  container_name: 'b4eb7b71-f032-474e-9f37-47f50361511c-azureml-blobstore',

  // SAS (Shared Access Signature) token for Azure Storage access control.
  // Provides permissions to read, write, and delete within the specified resources.
  // Includes parameters for storage version, service type, resource types,
  sas_token:
    '?sp=racwdl&st=2025-09-29T05:13:23Z&se=2040-10-29T05:04:55Z&sv=2024-11-04&sr=c&sig=kOoNTYJ4c9X%2FOnr4Pcfs%2F%2F7rZXq9NXROmhEHcQGKapE%3D',
}

// export const base_url_be =
//   global.environment == 'prod'
//     ? 'https://bloom-be-prod.azurewebsites.net/'
//     : global.environment == 'dev'
//       ? 'https://bloom-be-dev.azurewebsites.net/'
//       : 'http://127.0.0.1:3333/'

/**
 * `base_url_be` - Base URL for backend services.
 * Determines the URL based on the selected environment setting.
 * @type {string}
 */
export const base_url_be =
  global.environment == 'prod'
    ? 'https://indosvm3.westeurope.cloudapp.azure.com:59163/'
    : global.environment == 'dev'
      ? 'https://indosvm3.westeurope.cloudapp.azure.com:59165/'
      : 'http://127.0.0.1:3333/'

/**
 * `base_url` - Base URL for the frontend services.
 * Sets the URL according to the environment setting.
 * @type {string}
 */
export const base_url =
  global.environment == 'prod'
    ? 'https://bloomapp.nl/'
    : global.environment == 'dev'
      ? 'https://indosvm3.westeurope.cloudapp.azure.com:59164/'
      : 'http://localhost:5173/'
